import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "uk-text-muted uk-text-small cte-empty"
}
const _hoisted_2 = {
  key: 1,
  class: "cte"
}
const _hoisted_3 = { class: "uk-table uk-table-small uk-table-striped uk-table-divider uk-table-hover cte-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContainerTerminalEventsTableRowV2 = _resolveComponent("ContainerTerminalEventsTableRowV2")!
  const _component_ContainerTerminalEventsTableRowV1 = _resolveComponent("ContainerTerminalEventsTableRowV1")!

  return (_openBlock(), _createElementBlock("div", null, [
    ((_ctx.containerEvents || []).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No terminal events yet. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th"),
                _createElementVNode("th"),
                _createElementVNode("th"),
                _createElementVNode("th", {
                  colspan: "5",
                  style: {"text-align":"center","border-bottom":"3px double black","padding":"0"}
                }, "Holds"),
                _createElementVNode("th"),
                _createElementVNode("th")
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "cte-date-col" }, "Date"),
                _createElementVNode("th", { class: "cte-condensed-col" }, "Available?"),
                _createElementVNode("th", { class: "cte-lcation-col" }, "Location"),
                _createElementVNode("th", { class: "cte-condensed-col" }, "Customs"),
                _createElementVNode("th", { class: "cte-condensed-col" }, "Shipline"),
                _createElementVNode("th", { class: "cte-condensed-col" }, "Terminal"),
                _createElementVNode("th", { class: "cte-condensed-col" }, "USDA"),
                _createElementVNode("th", { class: "cte-condensed-col" }, "Other"),
                _createElementVNode("th", { class: "cte-condensed-col" }, "Demurrage (Fees)"),
                _createElementVNode("th", { class: "" }, "Last Free Day")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayRows, (row, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                  (_ctx.getIsV2Row(row))
                    ? (_openBlock(), _createBlock(_component_ContainerTerminalEventsTableRowV2, {
                        key: 0,
                        row: row,
                        "previous-row": _ctx.displayRows?.[idx + 1],
                        terminal: _ctx.terminal
                      }, null, 8, ["row", "previous-row", "terminal"]))
                    : (_openBlock(), _createBlock(_component_ContainerTerminalEventsTableRowV1, {
                        key: 1,
                        row: row,
                        "previous-row": _ctx.getPreviousV1Row(idx),
                        terminal: _ctx.terminal
                      }, null, 8, ["row", "previous-row", "terminal"]))
                ], 64))
              }), 128))
            ])
          ])
        ]))
  ]))
}